import { FadeUp } from "./Reveal";

const BENEFITS = [
        {
                title: "Your business, designed in Natant",
                desc: "NMI models your journeys, domains and KPIs from how you actually want to run.",
                icon: (
                        <path d="M8 3h8l4 4v14H8z M12 3v4h4 M11 12h6 M11 16h6" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                ),
        },
        {
                title: "A forward-deployed team",
                desc: "Senior engineers sit with your people, and we ship to you every week.",
                icon: (
                        <g fill="none" stroke="currentColor" strokeWidth="1.5">
                                <circle cx="10" cy="8" r="3" />
                                <circle cx="18" cy="8" r="3" />
                                <path d="M4 21v-2a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v2 M15 14h2a5 5 0 0 1 5 5v2" />
                        </g>
                ),
        },
        {
                title: "Founding-partner terms",
                desc: "Pilot pricing with an outcome share, locked in for founding members.",
                icon: (
                        <path d="M4 8l6-4 6 4-6 4z M4 8v8l6 4 6-4V8 M10 12v8" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                ),
        },
        {
                title: "A say in the roadmap",
                desc: "A direct line to the founder; features built around your journeys.",
                icon: (
                        <path d="M4 20V10 M10 20V4 M16 20v-8 M22 20v-5 M2 20h20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                ),
        },
];

export default function MembersGet() {
        return (
                <section id="members" data-testid="members-section" className="relative py-12 md:py-16 border-t border-[var(--border-line)]">
                        <div className="max-container">
                                <FadeUp>
                                        <div className="step-eyebrow mb-5">Join our cohort</div>
                                        <h2 className="h2x text-3xl md:text-5xl max-w-[22ch] mb-8 md:mb-10">
                                                Be one of the first <span className="acc">Super Companies</span>
                                        </h2>
                                </FadeUp>

                                <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-[var(--border-line)] mb-6">
                                        {BENEFITS.map((b, i) => (
                                                <FadeUp key={b.title} delay={0.07 * i} className="border-r border-b border-[var(--border-line)]">
                                                        <div className="p-6 md:p-8 h-full" data-testid={`member-benefit-${i}`}>
                                                                <div className="w-11 h-11 rounded-xl border border-[var(--border-strong)] flex items-center justify-center mb-6 acc">
                                                                        <svg viewBox="0 0 24 24" className="w-5 h-5">{b.icon}</svg>
                                                                </div>
                                                                <div className="font-display font-bold text-xl tracking-tight mb-2">{b.title}</div>
                                                                <p className="text-sm md:text-base text-[var(--bone-dim)] leading-relaxed">{b.desc}</p>
                                                        </div>
                                                </FadeUp>
                                        ))}
                                </div>

                                <FadeUp delay={0.15}>
                                        <div
                                                className="rounded-2xl p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 md:gap-10"
                                                style={{ background: "var(--accent-green)" }}
                                                data-testid="members-cta-band"
                                        >
                                                <div className="flex-1">
                                                        <div className="font-display font-bold text-2xl md:text-3xl tracking-tight text-white mb-2">
                                                                One system, not siloed — with every business journey holding to its KPIs.
                                                        </div>
                                                        <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-white/75">
                                                                One of three founding seats is open
                                                        </div>
                                                </div>
                                                <a
                                                        href="/apply"
                                                        data-testid="members-cta-apply"
                                                        className="pill-btn justify-center shrink-0"
                                                        style={{ background: "#fff", borderColor: "#fff", color: "var(--ink)" }}
                                                >
                                                        Apply for Cohort 1 <span aria-hidden>→</span>
                                                </a>
                                        </div>
                                </FadeUp>
                        </div>
                </section>
        );
}
